/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetIncludeKind =
  {
    Approve: "approve",
    Burn: "burn",
    Mint: "mint",
    Transfer: "transfer",
  } as const;
export type CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetIncludeKind =
  ClosedEnum<
    typeof CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetIncludeKind
  >;

export type CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest =
  {
    ledgerCanisterId: string;
    id: string;
    includeKind?:
      | Array<
        CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetIncludeKind
      >
      | undefined;
    start?: number | undefined;
    end?: number | undefined;
  };

/** @internal */
export const CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetIncludeKind$inboundSchema:
  z.ZodNativeEnum<
    typeof CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetIncludeKind
  > = z.nativeEnum(
    CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetIncludeKind,
  );

/** @internal */
export const CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetIncludeKind$outboundSchema:
  z.ZodNativeEnum<
    typeof CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetIncludeKind
  > =
    CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetIncludeKind$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetIncludeKind$ {
  /** @deprecated use `CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetIncludeKind$inboundSchema` instead. */
  export const inboundSchema =
    CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetIncludeKind$inboundSchema;
  /** @deprecated use `CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetIncludeKind$outboundSchema` instead. */
  export const outboundSchema =
    CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetIncludeKind$outboundSchema;
}

/** @internal */
export const CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest$inboundSchema:
  z.ZodType<
    CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    id: z.string(),
    include_kind: z.array(
      CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetIncludeKind$inboundSchema,
    ).optional(),
    start: z.number().optional(),
    end: z.number().optional(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
      "include_kind": "includeKind",
    });
  });

/** @internal */
export type CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest$Outbound =
  {
    ledger_canister_id: string;
    id: string;
    include_kind?: Array<string> | undefined;
    start?: number | undefined;
    end?: number | undefined;
  };

/** @internal */
export const CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest$outboundSchema:
  z.ZodType<
    CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest$Outbound,
    z.ZodTypeDef,
    CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    id: z.string(),
    includeKind: z.array(
      CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetIncludeKind$outboundSchema,
    ).optional(),
    start: z.number().optional(),
    end: z.number().optional(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
      includeKind: "include_kind",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest$ {
  /** @deprecated use `CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest$inboundSchema;
  /** @deprecated use `CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest$outboundSchema;
  /** @deprecated use `CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest$Outbound` instead. */
  export type Outbound =
    CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest$Outbound;
}

export function countTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequestToJSON(
  countTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest:
    CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest,
): string {
  return JSON.stringify(
    CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest$outboundSchema
      .parse(
        countTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest,
      ),
  );
}

export function countTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest' from JSON`,
  );
}
